// @flow

export default () => ({});
